import { render, staticRenderFns } from "./DeliverySummary.vue?vue&type=template&id=3a23575e&scoped=true"
import script from "./DeliverySummary.vue?vue&type=script&lang=js"
export * from "./DeliverySummary.vue?vue&type=script&lang=js"
import style0 from "./DeliverySummary.vue?vue&type=style&index=0&id=3a23575e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23575e",
  null
  
)

export default component.exports